var React = require('react');

function Alert (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_44718","data-name":"Group 44718","transform":"translate(-415 -418)"},[React.createElement("rect",{"id":"Rectangle_38105","data-name":"Rectangle 38105","width":"16","height":"16","transform":"translate(415 418)","fill":"none","key":0}),React.createElement("path",{"id":"Polygon_492","data-name":"Polygon 492","d":"M10.5,0,14,6l-3.5,6h-7L0,6,3.5,0Z","transform":"translate(416 420)","fill":"#ff3a00","key":1}),React.createElement("rect",{"id":"Rectangle_38104","data-name":"Rectangle 38104","width":"6","height":"2","transform":"translate(420 425)","fill":"#fff","key":2})]));
}

Alert.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = Alert;

Alert.default = Alert;
